export default __webpack_public_path__ + "static/media/chip_100.4e08b1e0.svg";